export default __webpack_public_path__ + "static/media/hexospark-icon.fbbc61f5.svg";